import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import PasswordField from '../components/PasswordField';
import './Login.css';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate       = useNavigate();
  const token          = searchParams.get('token') || '';

  const [password,  setPassword]  = useState('');
  const [password2, setPassword2] = useState('');
  const [error,     setError]     = useState('');
  const [loading,   setLoading]   = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password !== password2) {
      setError('Passwörter stimmen nicht überein.');
      return;
    }
    if (password.length < 8) {
      setError('Passwort muss mindestens 8 Zeichen lang sein.');
      return;
    }
    setLoading(true);
    try {
      await api.resetPassword(token, password);
      navigate('/login', { state: { successMessage: 'Passwort erfolgreich geändert. Du kannst dich jetzt anmelden.' } });
    } catch (err) {
      setError(err.message || 'Fehler beim Zurücksetzen.');
    } finally {
      setLoading(false);
    }
  }

  if (!token) {
    return (
      <div className="login-page">
        <div className="login-container">
          <div className="error-message">Ungültiger Link. Bitte fordere einen neuen Reset-Link an.</div>
          <div style={{ textAlign: 'center', marginTop: '1rem' }}>
            <Link to="/forgot-password" className="btn btn-secondary">Neuen Link anfordern</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <div className="login-title">
            <span className="logo-strix">Strix</span><span className="logo-ly">ly</span>
          </div>
          <p>Neues Passwort setzen</p>
        </div>

        {error && <div className="error-message fade-in">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="password">Neues Passwort</label>
            <PasswordField
              id="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Neues Passwort (min. 8 Zeichen)"
              autoComplete="new-password"
              showStrength
              showGenerator
              onGenerate={pw => { setPassword(pw); setPassword2(pw); }}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password2">Passwort bestätigen</label>
            <PasswordField
              id="password2"
              value={password2}
              onChange={e => setPassword2(e.target.value)}
              placeholder="Passwort wiederholen"
              autoComplete="new-password"
            />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }}
            disabled={loading || !password || !password2}>
            {loading ? 'Speichere…' : 'Passwort speichern'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
